/* ================================================== */
/* OBJECT FIT IMAGES
/* ================================================== */

$(document).ready(function(){

	var $images = $('.header__cover, .medias__item a');
	objectFitImages($images);

});